import {
    AfterViewInit,
    Component,
    EventEmitter,
    Inject,
    Input,
    LOCALE_ID,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import {
    ArcComponent,
    ArcOptions,
    VerticalComponent,
    VerticalOptions,
} from '@cmps/ng-chart';
import { TranslateService } from '@ngx-translate/core';

import { CmpsDecimalPipe } from '../common/number.pipe';
import {
    ScreenReaderTableData,
    ScreenReaderTableOptions,
} from '../common/screen-reader-table.component';

import {
    DualChartPerformanceComparison,
    Pillar,
} from './dual-chart-performance-comparison.widget.model';

@Component({
    selector: 'cmps-widget-pie-bar',
    templateUrl: './pie-bar.widget.component.html',
})
export class PieBarWidgetComponent implements OnInit, AfterViewInit {
    @ViewChild('arc') private readonly _arc: ArcComponent;
    @ViewChild('vertical') private readonly _vertical: VerticalComponent;

    @Input() data: DualChartPerformanceComparison;
    @Input() hasPieBarClick: DualChartPerformanceComparison;

    @Output() pieBarClick: EventEmitter<{
        which: PieBarWidgetComponent;
        pillar: Pillar;
    }>;

    pieOptions: ArcOptions;
    barOptions: VerticalOptions;
    srTableOptions: ScreenReaderTableOptions;
    srTableData: ScreenReaderTableData;

    constructor(
        @Inject(LOCALE_ID) private readonly _locale: string,
        private readonly _translateService: TranslateService,
        private readonly _decimalPipe: CmpsDecimalPipe,
    ) {
        this.pieBarClick = new EventEmitter();
    }

    ngOnInit(): void {
        // const dp = new DecimalPipe(this._locale);
        this.pieOptions = {
            rect: { width: '100%', height: 100, top: 5, right: 5, bottom: 5 },
            label: {
                formatter: () =>
                    this.data.piePillar.actual == null
                        ? '-'
                        : this._decimalPipe.transform(
                              this.data.piePillar.actual,
                              '1.1-1',
                          ),
                maxFontSize: 23,
            },
            // annotation: (maker: any, annotation: any, d: any, i: number) => annotation.note = {
            //     title: `${this._translateService.instant(TranslationKeyMap._768___TO_TARGET)} - ${dp.transform(this.data.d3.data.pie[0].y, '1.1-1')}`, //TODO revise tl
            //     align: 'middle'
            // }
        };

        if (this.data.d3.data.bar) {
            this.barOptions = {
                rect: { width: '100%', height: 125, top: 10 },
                xRotate: -45,
                yDomain: () => this.data.d3.options.bar.yDomain,
                yAxis: (yAxis) => yAxis.ticks(5),
                // annotation: (maker: any, annotation: any, d: any, i: number) => annotation.note = {
                //     title: `${this._translateService.instant(TranslationKeyMap._726_TARGET)} - ${dp.transform(this.data.barPillars[i].targetValue, '1.1-1')}`, //TODO revise tl
                //     align: 'middle'
                // }
            };
        }

        this.srTableOptions = {
            role: this.hasPieBarClick ? 'grid' : 'table',
            label: this.data.piePillar.title,
        };
        this.srTableData = {
            headerRows: [['Area', 'Actual', 'Percent to Target']],
        };
        this.srTableData.bodyRows = [
            [
                `Pie chart: ${this.data.piePillar.thresholdTitle || '-'}`, // TODO revise
                this.data.piePillar.actual == null
                    ? '-'
                    : this._decimalPipe.transform(
                          this.data.piePillar.actual,
                          '1.1-1',
                      ),
                null,
            ],
        ];

        if (this.data.d3.data.bar) {
            this.srTableData.bodyRows = this.srTableData.bodyRows.concat(
                this.data.barPillars.map((value) => [
                    value.barTitle,
                    value.actual == null
                        ? '-'
                        : this._decimalPipe.transform(value.actual, '1.1-1'),
                    (value.percentToTarget || '-').toString(),
                ]),
            );
        }
    }

    ngAfterViewInit(): void {
        this._arc.render();
    }

    onPieBarClick($event: MouseEvent | KeyboardEvent): void {
        $event.preventDefault();
        if (!this.hasPieBarClick) {
            $event.stopPropagation();
            return;
        }
        this._arc.dismissAnnotations();
        if (this.data.d3.data.bar) {
            this._vertical.dismissAnnotations();
        }
        this.pieBarClick.emit({ which: this, pillar: this.data.piePillar });
    }
}
